/* ============================================================
   LEELARAV GREENS — SITE CONFIGURATION
   All dynamic business details live here. Edit once, updates everywhere.
   ============================================================ */

export const CONTACT_PERSON = "Maheshbhai";
export const CONTACT_MOBILE = "+919428483655";
export const CONTACT_MOBILE_DISPLAY = "+91 94284 83655";

export const WHATSAPP_NUMBER = "919428483655";
export const WHATSAPP_MESSAGE =
  "Hello Leelarav Greens, I would like to inquire about availability for an event.";
export const WHATSAPP_LINK = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(WHATSAPP_MESSAGE)}`;

export const BOOKING_EMAIL = "booking@leelaravgreens.com";

export const VENUE_ADDRESS =
  "S.no. 397, Dahegam, Naroda Rd, opp. Shivnagar Farm, Galudan Gam, Gandhinagar, Gujarat 382305";
export const GOOGLE_MAPS_QUERY =
  "LeelaRav Greens, S.no. 397, Dahegam, Naroda Rd, opp. Shivnagar Farm, Galudan Gam, Gandhinagar, Gujarat 382305";

/* <!-- INSERT FACEBOOK URL HERE --> */
export const FACEBOOK_URL = "https://facebook.com";
/* <!-- INSERT INSTAGRAM URL HERE --> */
export const INSTAGRAM_URL = "https://instagram.com";

/* <!-- INSERT GOOGLE BUSINESS REVIEW LINK HERE --> */
export const GOOGLE_REVIEWS_URL =
  "https://www.google.com/maps/place/LeelaRav+Greens/@23.1441603,72.7807716,19z/data=!3m1!4b1!4m6!3m5!1s0x395e7f99b67f999d:0xe3a266af09af1b56!8m2!3d23.1441603!4d72.7807716!16s%2Fg%2F11fqc9mnjx?entry=ttu&g_ep=EgoyMDI2MDcwNy4wIKXMDSoASAFQAw%3D%3D";

/* Reviews shown in the testimonial carousel.
   A hardcoded filter layer in Testimonials.jsx ONLY renders reviews
   with rating >= 4, guaranteeing a flawless premium reputation. */
export const REVIEWS = [
  { name: "Hardik Shah", rating: 5, date: "2 months ago", text: "We hosted my daughter's wedding at Leelarav Greens and it was nothing short of magical. The lawns at twilight with the fairy lights looked straight out of a fairytale. Maheshbhai and team handled everything flawlessly." },
  { name: "Priya Desai", rating: 5, date: "3 months ago", text: "The most premium party plot in the region. Spacious parking for all our 200+ guests' cars, spotless washrooms, and the AC rooms were a blessing for the family. Highly recommended for weddings." },
  { name: "Rajesh Mehta", rating: 4, date: "5 months ago", text: "Organized our annual corporate gala here. The large banquet comfortably seated 380 guests and the professional kitchen made catering seamless. Truly a grand venue." },
  { name: "Anjali Trivedi", rating: 5, date: "6 months ago", text: "Booked for our ring ceremony. The night illumination is breathtaking — every photo looked cinematic. The staff's hospitality made our guests feel like royalty." },
  { name: "Vikram Chaudhary", rating: 3, date: "7 months ago", text: "Decent venue but felt it could be better managed during peak hours." },
  { name: "Kiran Patel", rating: 5, date: "8 months ago", text: "From the pre-wedding shoot to the reception, everything at Leelarav Greens exceeded expectations. The manicured gardens are a photographer's dream." },
  { name: "Meera Joshi", rating: 4, date: "10 months ago", text: "Hosted a family function for 150 guests in the small banquet. Elegant, clean and beautifully lit. The guest rooms were spacious and comfortable." },
];
